"use client";

import { cn } from "@jesus-central-church/shared";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import { SbRichText as SbRichTextBlok } from "@storyblok/types/287435740670216/storyblok-components";
import { RichTextRenderer } from "../shared/storyblok-rich-text-renderer";

export function RichText({
  blok,
  pageData,
}: {
  blok: SbRichTextBlok;
  pageData: { locale: string };
}) {
  return (
    <RichTextRenderer
      {...storyblokEditable(blok as SbBlokData)}
      className={cn(`text-${blok.color}`)}
      document={blok.content!}
      pageData={pageData}
    />
  );
}
